import React from "react";

const Individual = () => {
  return (
    <div className="w-full h-screen">
      <iframe
        src="https://nk.lifecommando.in/widget/form/zWvn0JgB0GijGIAh5WZ6"
       style={{ width: "100%", height: "100%", border: "none",borderRadius: "3px" }}
        id="inline-zWvn0JgB0GijGIAh5WZ6"
        data-layout='{"id":"INLINE"}'
        data-trigger-type="alwaysShow"
        data-trigger-value=""
        data-activation-type="alwaysActivated"
        data-activation-value=""
        data-deactivation-type="neverDeactivate"
        data-deactivation-value=""
        data-form-name="Membership Individual Member Details"
        data-height="3633"
        data-layout-iframe-id="inline-zWvn0JgB0GijGIAh5WZ6"
        data-form-id="zWvn0JgB0GijGIAh5WZ6"
        title="Membership Individual Member Details"
      ></iframe>
      <script src="https://nk.lifecommando.in/js/form_embed.js"></script>
    </div>
  );
};

export default Individual;
